import './menu-dropdown.sass';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, I18n } from 'react-redux-i18n';

import ContentLoader from 'controls/content-loader/ContentLoader';

import transmit from 'actions/transmit';
import request from 'actions/request';
import exportTrack from 'actions/particular/exportTrack';
import formSubmit from 'actions/formSubmit';
import processTrack from 'actions/particular/processTrack';
import redirect from 'actions/redirect';

class MenuDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaderShown: false
    };
  }

  buildMenuItems(type) {
    const menuItems = {
      oneTrack: [
        'delete',
        'export',
        'process',
        'exportCoordinates',
        'removeSelection',
        'events',
        'params',
        'templates'
      ],
      manyItems: [
        'export',
        'delete',
        'removeSelection'
      ],
    };

    let currentMenuItems = menuItems[type];

    function ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return currentMenuItems.map(item => {
      if (typeof this['handle' + ucFirst(item)] === 'function') {
        return <li key={ item } >
          <a onClick={ this['handle' + ucFirst(item)].bind(this) }
            href='#'>{ I18n.t('tracksTable.menuDropdown.'+item) }
          </a>
        </li>;
      }
    });
  }

  buildMenu() {
    let flightsCount = this.props.tracks.chosenItems.length;

    if (flightsCount === 0) {
      return '';
    }

    let type = 'manyItems';
    if (flightsCount === 1) {
      type = 'oneTrack';
    }

    return(
      <li className='dropdown'>
        <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>
          <Translate value='tracksTable.menuDropdown.fileMenu' /><span className='caret'></span>
        </a>
        <ul className='dropdown-menu'>
          { this.buildMenuItems(type) }
        </ul>
      </li>
    );
  }

  handleDelete() {
    for (var ii = 0; ii < this.props.tracks.chosenItems.length; ii++) {
      let item = this.props.tracks.chosenItems[ii];
      this.props.request(
        ['tracks', 'delete'],
        'delete',
        'TRACK',
        { id: item.id }
      );
    }
  }

  handleExport() {
    let items = [];

    for (var ii = 0; ii < this.props.tracks.chosenItems.length; ii++) {
      items.push(this.props.tracks.chosenItems[ii].id);
    }

    this.props.exportTrack(items);
  }

  handleProcess() {
    if (this.props.tracks.chosenItems.length === 1) {
      this.setState({ isLoaderShown: true });
      this.props.processTrack({
        id: this.props.tracks.chosenItems[0].id
      }).then(() => {
        this.setState({ isLoaderShown: false });
      });
    }
  }

  handleExportCoordinates() {
    if (this.props.tracks.chosenItems.length === 1) {
      this.props.formSubmit({
        action: 'tracks/coordinates',
        controls: [{
          name: 'id',
          value: this.props.tracks.chosenItems[0].id
        }]
      });
    }
  }

  handleRemoveSelection() {
    this.props.transmit('TRACKS_UNCHOOSE_ALL');
  }

  handleEvents() {
    if (this.props.tracks.chosenItems.length === 1) {
      this.props.redirect('/track-events/' + this.props.tracks.chosenItems[0].id);
    }
  }

  handleParams() {
    if (this.props.tracks.chosenItems.length === 1) {
      this.props.redirect('/track-params/' + this.props.tracks.chosenItems[0].id);
    }
  }

  handleTemplates() {
    if (this.props.tracks.chosenItems.length === 1) {
      this.props.redirect('/track-templates/' + this.props.tracks.chosenItems[0].id);
    }
  }

  buildLoader() {
    if (this.state.isLoaderShown) {
      return (<li>
        <a href='#' className='tracks-tree-menu-dropdown__loader'>
          <ContentLoader margin={ 1 } size={ 30 } border= { 3 } />
        </a>
      </li>);
    }

    return '';
  }

  render() {
    return (
      <ul className='tracks-tree-menu-dropdown nav navbar-nav'>
        { this.buildMenu() }
        { this.buildLoader() }
      </ul>
    );
  }
}

function mapStateToProps(state) {
  return {
     tracks: state.tracks
   };
}

function mapDispatchToProps(dispatch) {
  return {
    transmit: bindActionCreators(transmit, dispatch),
    request: bindActionCreators(request, dispatch),
    exportTrack: bindActionCreators(exportTrack, dispatch),
    formSubmit: bindActionCreators(formSubmit, dispatch),
    processTrack: bindActionCreators(processTrack, dispatch),
    redirect: bindActionCreators(redirect, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuDropdown);
